import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchAlbum = (albumId = null, query = {}, config = {}) => apiVoissa.get(`/albums/${albumId}?${qs.stringify(query)}`, config);

export const fetchAlbumMedias = (albumId = null, query = {}, config = {}) => apiVoissa.get(`/albums/${albumId}/medias?${qs.stringify(query)}`, config);
export const reportAlbum = (albumId = null, data = {}, config = {}) => apiVoissa.post(`/albums/${albumId}/reporting`, data, config);

export const createMediaAlbum = (albumId = null, data = {}, config = {}) => apiVoissa.post(`/albums/${albumId}/medias`, data, config);

export const ALBUMS_KEY = `albums`;

export const ALBUM_KEY = `album`;
export const ALBUM_MEDIAS_KEY = `album-medias`;